import { genMessage } from '../helper';
// import elementPlus from 'element-plus/dist/locale/zh-tw.mjs';
// 修改文件
const modules = import.meta.glob('./hk/*.ts', { eager: true });
export default {
	message: {
		...genMessage(modules, 'hk'),
	},
	// dateLocale: elementPlus,
	dateLocaleName: 'Hk',
};
